import { type Article } from '../lib/supabase';

interface TimelineMenuProps {
  articles: Article[];
  onArticleClick: (article: Article) => void;
}

export function TimelineMenu({ articles, onArticleClick }: TimelineMenuProps) {
  const formatDate = (date: string | null) => {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  const sortedArticles = [...articles].sort((a, b) => {
    const dateA = a.published_at ? new Date(a.published_at).getTime() : 0;
    const dateB = b.published_at ? new Date(b.published_at).getTime() : 0;
    return dateB - dateA;
  });

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h2 className="text-xl font-semibold mb-6">Linha do Tempo</h2>
      <div className="space-y-6 max-h-[70vh] overflow-y-auto pr-4 custom-scrollbar">
        {sortedArticles.map((article) => (
          <div
            key={article.id}
            className="flex items-start space-x-4 cursor-pointer hover:bg-gray-50 p-2 rounded-md transition-colors duration-200"
            onClick={() => onArticleClick(article)}
          >
            <div className="flex-1">
              <h3 className="text-sm font-medium text-gray-900 line-clamp-2">
                {article.title}
              </h3>
              <p className="text-sm text-gray-500 mt-1">
                {formatDate(article.published_at)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
